/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// import Vue from 'vue';
// import axios from 'axios';

import Promise from 'promise-polyfill'; //fix for IE browsers using EM6 promises
import 'isomorphic-fetch'; //fix for IE browsers
import 'es6-object-assign/auto'; //fix for datepicker in IE
import 'babel-plugin-transform-object-assign'; //fix for datepicker in IE
import "core-js";

window.Vue = require('vue');
window.axios = require('axios');
window.Vue.prototype.$http = axios;

/**
 * Register Componets
 */
Vue.component('navbar', require('./components/ui/Navbar.vue'));
Vue.component('footerbar', require('./components/ui/Footer.vue'));

import OnlineForm from '../../../Modules/OnlineForm/Resources/assets/js/app';
import Register from '../../../Modules/Register/Resources/assets/js/app';
import CityPlan from '../../../Modules/CityPlan/Resources/assets/js/app';
import Wards from './components/our-council/wards';
import WelcomeToCountry from './components/community/atsi/welcome-to-country';
import Sala from './components/events/sala/sala';
import MobileFoodVendor from '../../../Modules/MobileFoodVendor/Resources/assets/js/app';

Vue.component('games', require('./components/thelights/Games.vue'));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import VueApollo from "vue-apollo";
Vue.use(VueApollo);
import ApolloClient from "apollo-boost";
const apolloClient = new ApolloClient({
    // Add absolute project URL here:
    // If your setup has multiple projects, use respective key else default should be '_'
    // More info: https://docs.directus.io/api/reference.html#project-prefix
    uri: "http://api-lights.online2/_/gql?access_token=eyJpZCI6MSwiZXhwIjoxNTY4MTgyODgzLCJ0eXBlIjoiYXV0aCIsImtleSI6Ijx0eXBlLWEtcHVibGljLWF1dGhlbnRpY2F0aW9uLWtleS1zdHJpbmc-IiwicHJvamVjdCI6Il8ifQ.loE6_gzNTmaNJqXb-8NJE6Nbxrvm5KDVSVmSNfTk3fM"
});

const apolloProvider = new VueApollo({
    defaultClient: apolloClient
});

const app = new Vue({
    el: '#app',
    apolloProvider
});


// WEBPACK FOOTER //
// ./resources/assets/js/app.js